import React from "react";
import {
  Container,
  Flex,
  Image,
  Tile,
  Title,
  TilesContainer,
  Text
} from "../ui";
import { SVGCarousel, TileList } from "../components";
import { WindowSize } from "react-fns";
import styled from "styled-components";
import { WEBSITES, PROJECTS } from "../assets/svg";
import project1 from "../assets/project1.jpg";
import project2 from "../assets/project2.jpg";

const ServicesContainer = styled(Container)`
  /* height: calc(100vh - 135px); */
  padding-bottom: 10rem;
  position: relative;
`;

const websites = [WEBSITES];
const projects = [PROJECTS];

const Services = () => {
  return (
    <WindowSize
      render={({ width }) => (
        <>
          <TilesContainer>
            {width >= 769 ? (
              <>
                <Tile style={{ flex: 0.5 }} />
                <Tile />
                <Tile />
                <Tile />
                <Tile />
                <Tile />
                <Tile style={{ flex: 0.5 }} />
              </>
            ) : (
              <>
                <TileList number="4" />
              </>
            )}
          </TilesContainer>
          <ServicesContainer padding="5rem 2rem">
            <Flex column justifyContent="space-between" fillHeight>
              <Flex justifyContent="space-between" width="50%">
                <Flex width="auto" column>
                  <SVGCarousel items={projects} relative opacity />
                  <Title>Our Work</Title>
                </Flex>
                <Text>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </Text>
              </Flex>
              <Flex>
                <Image src={project1} />
                <Image src={project2} />
                <Image src={project1} />
                <Image src={project2} />
              </Flex>
              {/* <span /> */}
              <SVGCarousel items={websites} relative />
            </Flex>
          </ServicesContainer>
        </>
      )}
    />
  );
};
export default Services;
